export default "__VITE_ASSET__g8P8sKqD__";